// Hidden items (Now means `chunk`)
export const CHeader = "h:";

// Plug-in Stored Container (Obsolete)
export const PSCHeader = "ps:";
export const PSCHeaderEnd = "ps;";

// Internal data Container
export const ICHeader = "i:";
export const ICHeaderEnd = "i;";
export const ICHeaderLength = ICHeader.length;

// Internal data Container (eXtended)
export const ICXHeader = "ix:";
